import { gql } from '@ori/fetching';

const productWithPermissionFragment = gql`
  fragment ProductWithPermissions on Product {
    permission {
      canDisplay
    }
    productCode
  }
`;

export const productPermissionsQuery = gql`
  ${productWithPermissionFragment}
  query GetProductPermissions($productCodes: [ID!]) {
    products(productCodes: $productCodes) {
      ...ProductWithPermissions
    }
  }
`;
